<template>
  <div class="wrapper questions">
    <header>
      <router-link to="/"
        ><img src="@/assets/images/logo-mixa-min.png"
      /></router-link>
    </header>
    <main
      class="h-full bg-white flex flex-wrap items-start justify-center gothambook"
    >
      <div class="w-full">
        <img class="question-img" src="@/assets/images/quiz.png" />

        <ul class="question_wrapper">
          <li v-for="(item, i) in questions" :key="item.question">
            <div v-if="i === question" class="text-center relative">
              <div
                v-if="between"
                class="absolute inset-0 w-full h-full bg-transparent !cursor-default z-50"
              ></div>
              <h2 v-html="item.question" />

              <p
                @click="selectAnswers(i)"
                :class="{
                  'bg-green-100 text-green-700 animate__animated animate__heartBeat':
                    (valide && selected === i) || correct === i,

                  'bg-red-100 text-red-700 animate__animated animate__shakeX':
                    !valide && selected === i,
                }"
                v-for="(item, i) in item.answers"
                :key="i"
              >
                {{ item.reponse }}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="absolute opacity-0 w-1 h-1">
        <audio id="audio" src="/sounds/win.mp3"></audio>
        <audio id="audio2" src="/sounds/wrong.mp3"></audio>
      </div>
    </main>
    <footer>
      <div class="bg-white flex flex-wrap -mt-1 justify-center">
        <button class="next" @click="nextQuestion">SUIVANT</button>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      between: false,
      correct: null,
      resultats: [],
      selected: null,
      valide: false,
      invalid: false,
      question: 0,
      id: null,
      questions: [
        {
          question:
            "En quelle année a été créée<br>la marque <strong>Mixa</strong> ?",
          answers: [
            { reponse: "1924" },
            { reponse: "1934" },
            { reponse: "1954" },
          ],
        },
        {
          question:
            "Quel était le <strong>métier</strong><br>du créateur de la marque<br><b>Mixa</b> ?",
          answers: [
            { reponse: "Docteur en pharmacie" },
            { reponse: "Chercheur en dermatologie" },
            { reponse: "Médecin généraliste" },
          ],
        },
        {
          question:
            "<strong>Mixa</strong> propose<br>des <strong>produits</strong> pour :",
          answers: [
            { reponse: "Le corps" },
            { reponse: "Le visage" },
            { reponse: "Les deux" },
          ],
        },
        {
          question:
            "La <strong>niacinamide</strong><br>aussi appelée <strong>Vitamine b3</strong><br>est reconnue pour ses propriétés :",
          answers: [
            { reponse: "Hydratante et apaisante" },
            { reponse: "De protection solaire" },
            { reponse: "Anti-rides" },
          ],
        },
        {
          question: "Les <strong>céramides</strong><br>permettent de :",
          answers: [
            { reponse: "Renforcer la barrière cutanée" },
            { reponse: "Masquer l'acné" },
            { reponse: "Faire bronzer" },
          ],
        },
      ],
    };
  },
  mounted() {
    this.id = this.$route.params.id;
  },
  methods: {
    play(num) {
      // let audio = document.getElementById("audio");
      // let audio2 = document.getElementById("audio2");
      // audio.pause();
      // audio.currentTime = 0;
      // audio2.pause();
      // audio2.currentTime = 0;

      setTimeout(() => {
        if (num === 1) {
          //   audio.volume = 0.2;
          //   audio.play();
        } else {
          // audio2.volume = 0.2;
          // audio2.play();
        }
      }, 200);
    },
    selectAnswers(i) {
      this.valide = false;
      this.correct = 12;
      this.between = true;

      this.selected = i;
      if (this.question === 0 && i === 0) {
        this.valide = true;
      }
      if (this.question === 1 && i === 0) {
        this.valide = true;
      }
      if (this.question === 2 && i === 2) {
        this.valide = true;
      }
      if (this.question === 3 && i === 0) {
        this.valide = true;
      }
      if (this.question === 4 && i === 0) {
        this.valide = true;
      }

      if (this.valide) {
        // this.play(1);
      } else {
        // this.play(2);
        setTimeout(() => {
          if (this.question === 0) this.correct = 0;
          if (this.question === 1) this.correct = 0;
          if (this.question === 2) this.correct = 2;
          if (this.question === 3) this.correct = 0;
          if (this.question === 4) this.correct = 0;
        }, 1000);
      }
    },
    nextQuestion() {
      this.between = false;
      this.correct = 12;
      if (this.selected === null) {
        return;
      }
      if (this.question < this.questions.length - 1) {
        this.resultats.push({ qestion: this.question, reponse: this.selected });
        this.selected = null;
        this.question++;
      } else {
        this.$router.push("/end");
      }
    },
  },
};
</script>
